import React from 'react';
import { useSelector } from 'react-redux';

import { useIntl } from 'ha/i18n';
import { Grid } from '@ha/dsl';
import { City } from 'ha/services/apiV2/types';

import { getFeaturedCities } from 'ha/modules/FeaturedCities/selectors';

import {
  filterApartments,
  filterPrivateRooms,
  citiesToFeaturedLinks,
} from '../../utils';

import {
  FeaturedLinksTitle,
  FeaturedLinksWrapper,
  FeaturedLinksContent,
} from '../FeaturedLinks/FeaturedLinks';

export const ApartmentsAndRooms: React.FC = () => {
  const { T } = useIntl();

  const featuredCities = useSelector(getFeaturedCities);

  if (featuredCities.length === 0) {
    return null;
  }

  const apartmentsCities: City[] = filterApartments(featuredCities);
  const roomsCities: City[] = filterPrivateRooms(featuredCities);

  return (
    <FeaturedLinksWrapper slightlyGray>
      <Grid container>
        <Grid item xs={8}>
          <FeaturedLinksTitle
            align="left"
            titles={[T('Featured apartments for rent')]}
          />
        </Grid>
        <Grid item xs={4}>
          <FeaturedLinksTitle
            align="left"
            titles={[T('Featured private rooms for rent')]}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={8}>
          <FeaturedLinksContent
            items={citiesToFeaturedLinks(apartmentsCities)}
            maxItemsPerColumn={9}
          />
        </Grid>
        <Grid item xs={4}>
          <FeaturedLinksContent
            items={citiesToFeaturedLinks(roomsCities)}
            maxItemsPerColumn={4}
          />
        </Grid>
      </Grid>
    </FeaturedLinksWrapper>
  );
};
